import appRouter from 'routes/router';

export const routerStorePlugin = (store) => {
  store.subscribe((mutation, state) => {
    if (mutation.type === 'logout' && !window?.location?.pathname?.includes('/auth/login')) {
      appRouter.push('/auth/login');
    }
  });
};
